import { useState } from "react";
import { RailCard, RailRow, railInput, railLink } from "./RailCard";
import { getDefaultFreightMargin } from "../proposalUtils";

const FIELDS = [["material", "Material GM %", 50], ["labor", "Labor GM %", 73.3], ["freight", "Freight GM %", null]];
const isSet = (v) => v != null && v !== "";

// Proposal-wide GM% defaults. Blank = library / system default. "Apply to all" overwrites every existing line.
export function MarginsCard({ defaults, onChange, onApplyAll, lineCount }) {
  const [confirm, setConfirm] = useState(false);
  const d = defaults || {};
  const anySet = FIELDS.some(([k]) => isSet(d[k]));
  return (
    <RailCard title="MARGINS" testId="rail-margins">
      {FIELDS.map(([k, label, fallback]) => (
        <RailRow key={k} label={label} hint="Used for every line added to this proposal from now on">
          <input type="number" step="1" min="0" max="99" value={isSet(d[k]) ? d[k] : ""} placeholder={String(fallback ?? getDefaultFreightMargin())}
            onChange={(e) => onChange({ ...d, [k]: e.target.value })} onFocus={(e) => e.target.select()}
            className={railInput} data-testid={`rail-margin-${k}`} />
        </RailRow>
      ))}
      <RailRow label={<span className="text-[11px]">Defaults for New Lines</span>} testId="rail-margins-footer">
        {!confirm ? (
          <button type="button" className={railLink} disabled={!anySet || !lineCount} onClick={() => setConfirm(true)}
            title={anySet ? "Overwrite the GM% on every existing line with these defaults" : "Type a margin first"} data-testid="rail-margins-apply-all">
            Apply to All {lineCount} Line{lineCount === 1 ? "" : "s"}
          </button>
        ) : (
          <span className="flex items-center gap-1.5 text-[11px]" data-testid="rail-margins-apply-confirm-row">
            <span className="text-amber-700">Overwrite {lineCount}?</span>
            <button type="button" className="font-semibold text-emerald-700 hover:underline" onClick={() => { onApplyAll(); setConfirm(false); }} data-testid="rail-margins-apply-confirm">Yes</button>
            <button type="button" className="text-slate-500 hover:underline" onClick={() => setConfirm(false)} data-testid="rail-margins-apply-cancel">No</button>
          </span>
        )}
      </RailRow>
    </RailCard>
  );
}
